export default __webpack_public_path__ + "static/media/aa.e591a57d.jpg";